import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaDownload } from 'react-icons/fa';
import perfilImg from '../../assets/Principal/perfil.jpg';
import { useLang } from '../../context/LangContext';
import './AboutSection.css';

export default function AboutSection() {
  const { t, lang } = useLang();
  const a = t.about;
  const cvFile = lang === 'pt' ? 'Curriculo_PT-BR_Alan_Souza.pdf' : 'Resume_EN_Alan_Souza.pdf';

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <motion.div
          className="about-content"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
        >
          <span className="about-code">{a.tag}</span>
          <h1 className="about-title">
            {a.title}<span className="about-highlight">.</span>
          </h1>
          <p className="about-desc">{a.desc}</p>

          <div className="about-stats">
            {a.stats.map((s, i) => (
              <motion.div
                className="about-stat"
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: 0.1 * i }}
              >
                <span className="about-stat-value">{s.value}</span>
                <span className="about-stat-label">{s.label}</span>
              </motion.div>
            ))}
          </div>

          <div className="about-actions">
            <a href={`${process.env.PUBLIC_URL}/${cvFile}`} download={cvFile} className="about-btn">
              <FaDownload />
              {a.btnCV}
            </a>
            <div className="about-socials">
              <a href="https://github.com/Alan-VSouza" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="about-social-link">
                <FaGithub size={24} />
              </a>
              <a href="https://www.linkedin.com/in/alanvasconi/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="about-social-link">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="about-img-wrapper"
          initial={{ opacity: 0, scale: 0.93, y: 24 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, amount: 0.45 }}
          transition={{ duration: 1.1 }}
        >
          <div className="about-img-bg"></div>
          <img src={perfilImg} alt="Alan Souza" className="about-img" loading="lazy" />
        </motion.div>
      </div>
    </section>
  );
}